// import React from 'react'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import facebook from "../../assets/images/profile/Vector (1).png";
import linkedIn from "../../assets/images/profile/Vector (3).png";
import github from "../../assets/images/profile/mdi_github.png";
import pintrest from "../../assets/images/profile/Vector (4).png";
import insta from "../../assets/images/profile/Vector (5).png";
import youtube from "../../assets/images/profile/Vector (6).png";
import Pdf from "../../assets/images/profile/pdf.png";
import Client from "../../assets/images/profile/IMG (1).png";
import axios from '../../API/axios';
import { Link } from 'react-router-dom';

const RecruiterProfile = () => {
    const userUID = localStorage.getItem('userUID')

    const [profileData, setProfileData] = useState('')
    const GetProfile = async () => {
        try {
            const res = await axios.get(`/Company/GetProfile?UID=${userUID}&CompType=Recruiter`);
            setProfileData(res.data.responseData)
            console.log("resss", res);

        }
        catch (error) {
            console.log('error', error);

        }
    };
    useEffect(() => {
        GetProfile()
    }, [])


    return (
        <>
            <div className="profile-resume-main-container pt-3">

                <div className="profile-resume-heading-cont d-flex align-items-center p-4">
                    <div className="profile-resume-empty-cont me-2"></div>
                    <h2>Overview</h2>
                </div>

                <div className="profile-resume-userinfo mb-3">
                    <div className="row p-4">
                        <div className="col-md-2">
                            <div className="profile-resume-image">
                                <img src={profileData.logoImage} alt="" srcset="" />
                            </div>
                        </div>
                        <div className="col-md-9 mt-3">
                        {profileData.tagline === null ? '' :(
                            <div className="profile-resume-designation f-14 f-600">
                                {profileData.tagline}
                            </div>
                        )}
                            <div className="d-flex align-items-center mb-3 Main-resume-username">
                                <div className="profile-resume-username me-2">
                                    {profileData.name}
                                </div>
                                {/* <div className="profile-resume-vector me-2 d-flex justify-content-center align-items-center">
                                    <img src="/" alt="" srcset="" />
                                </div>
                                <div className="profile-resume-available-btn">
                                    <Button>Avaialble now</Button>
                                </div> */}
                            </div>
                            <div className="d-flex Resume-Skills-Country-Mobile">
                                {/* <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                                    Blender
                                </div>
                                <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                                    Sketch
                                </div>
                                <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                                    Adobe XD
                                </div>
                                <div className="profile-resume-skills d-flex justify-content-center align-items-center f-12 f-500 me-2">
                                    Figma
                                </div> */}
                                <div className="profile-resume-country d-flex align-items-center">
                                {profileData.cityName === null ? '' : (

                                    <div className="profile-resume-country-icon d-flex  align-item-center me-3 f-18  f-400">
                                        <span class="icon-map-pin "></span>
                                        {profileData.cityName}
                                    </div>
                                )}
                                    {/* <div className="profile-resume-country-icon d-flex align-item-center f-18 f-400">
                                        <span class="icon-dolar1 me-1"></span>
                                        $ 200/ year
                                    </div> */}
                                </div>
                            </div>
                        </div>
                         
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4">


                        <div className="cv-form-details po-sticky job-sg single-stick email-cv-form-details profile-resume-userinfo ">
                            <ul className="list-infor email-list-infor">
                               {profileData.contactNo === null ? "" : (
                                    <li>
                                        <div className="category Notification-Text"> Phone Number
                                        </div>
                                        <div className="detail">{profileData.contactNo}</div>
                                    </li>
                                )}

                                {profileData.email === null ? "" : (
                                    <li className='only-for-email'>
                                        <div className="category Notification-Text">Email</div>
                                        <div className="detail">{profileData.email}</div>
                                    </li>
                                )}
 

                                {profileData.langName === null ? "" : (
                                    <li>
                                        <div className="category Notification-Text">Language</div>
                                        <div className="detail">   {profileData.langName}</div>
                                    </li>
                                )}
 

                                {profileData.website === null ? "" : (
                                    <li>
                                        <div className="category Notification-Text">Website Name</div>
                                        <div className="detail">{profileData.website}</div>
                                    </li>
                                )}
                                {profileData.website === null ? "" : (
                                    <li>
                                        <div className="category Notification-Text">Company Size</div>
                                        <div className="detail">{profileData.website}</div>
                                    </li>
                                )}
                                {profileData.websites === null ? "" : (
                                    <li>
                                        <div className="category Notification-Text">Company Category</div>
                                        <div className="detail">{profileData.website}</div>
                                    </li>
                                )}
                                {profileData.websites === null ? "" : (
                                    <li>
                                        <div className="category Notification-Text">Industry</div>
                                        <div className="detail">{profileData.website}</div>
                                    </li>
                                )}
                                {profileData.startedDate === null ? "" : (
                                    <li>
                                        <div className="category Notification-Text">Incorporate Date</div>
                                        <div className="detail">{profileData.startedDate}</div>
                                    </li>
                                )}
                                {profileData.startedDate === null ? "" : (
                                    <li>
                                        <div className="category Notification-Text">Address</div>
                                        <div className="detail">{profileData.startedDate}</div>
                                    </li>
                                )}


                            </ul>

                            {/* <div className="wd-social d-flex aln-center">
                                <span>Socials:</span>
                                <ul className="list-social d-flex aln-center">
                                    <li>
                                        <Link to="#">
                                            <i className="icon-facebook"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="icon-linkedin2"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="icon-twitter"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="icon-pinterest"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="icon-instagram1"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <i className="icon-youtube"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}

                        </div>
                    </div>

                    <div className="col-lg-8 Aboutme-Container-Profile">
                        <div className="profile-resume-parent-cont p-4 rounded-4">
                            {profileData.about === null ? "" : (
                                <div className="profile-resume-about">
                                    <div className="profile-resume-about-heading f-24 f-800 mb-3">
                                        About me
                                    </div>

                                    <div className="profile-resume-about-info">
                                        {profileData.about ? (
                                            <p className="f-16 f-400">{profileData.about}</p>
                                        ) : null}
                                    </div>
                                </div>
                            )}



                            {profileData.description ? (
                                <div className="profile-resume-education">
                                    <div className="profile-resume-about-heading f-24 f-800 mb-3">
                                        Education
                                    </div>
                                    <div className="d-flex">
                                        <div className="profile-resume-verticle-line me-4"></div>
                                        <div>
                                            <div className="profile-resume-education-details mb-3">
                                                <div className="profile-resume-university f-14 f-700">
                                                    {/* FPT University <span>2019 - 2021</span> */}
                                                </div>
                                                <div className="profile-resume-education-designation f-16 f-700">
                                                    {/* Graphic Design */}
                                                </div>
                                                <div className="profile-resume-education-designation-info f-14 f-400">
                                                    {profileData.description}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}


                            {/* <div className="profile-resume-user-acvtivity mt-4">
                                <div className="profile-resume-about-heading f-24 f-800 mb-3">
                                    User Activity Timeline
                                </div>

                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div className="profile-resume-applied-status me-2"></div>
                                        <div className="profile-resume-applied-jobs f-16 f-700">
                                            Applied to Jobs
                                        </div>
                                    </div>

                                    <div className="profile-resume-user-activity-time f-14 f-400">
                                        12 min ago
                                    </div>
                                </div>

                                <div className="profile-resume-user-actvity-container mb-3">
                                    <p className="f-14 f-400 mb-0">
                                        Invoices have been paid to the company
                                    </p>
                                    <div className="profile-resume-pdf-cont d-flex">
                                        <div className="profile-resume-pdf-icon me-3">
                                            <img src={Pdf} alt="" srcset="" />
                                        </div>
                                        <div className="profile-resume-pdf-text f-14 f-700">
                                            CV_ TONY.pdf
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div className="profile-resume-applied-status me-2 profile-resume-success-icon"></div>
                                        <div className="profile-resume-applied-jobs f-16 f-700">
                                            Meeting with john
                                        </div>
                                    </div>
                                    <div className="profile-resume-user-activity-time f-14 f-400">
                                        45 min ago
                                    </div>
                                </div>

                                <div className="profile-resume-user-actvity-container">
                                    <p className="f-14 f-400 mb-0">
                                        Interview meeting with john @10:15am
                                    </p>
                                    <div className="profile-resume-pdf-cont d-flex">
                                        <div className="profile-resume-pdf-icon me-3">
                                            <img src={Client} alt="" srcset="" />
                                        </div>
                                        <div>
                                            <div className="profile-resume-pdf-text f-14 f-700">
                                                John Doe (Client)
                                            </div>
                                            <p>Interview meeting with john @10:15am</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div className="profile-resume-applied-status me-2 profile-resume-cv-icon"></div>
                                        <div className="profile-resume-applied-jobs f-16 f-700">
                                            Upload CV
                                        </div>
                                    </div>

                                    <div className="profile-resume-user-activity-time f-14 f-400">
                                        5 day ago
                                    </div>
                                </div>
                                <div className="profile-resume-user-actvity-container">
                                    <p className="f-14 f-400">
                                        Interview meeting with john @10:15am
                                    </p>
                                </div>
                            </div> */}
                        </div>

                    </div>
                </div>


            </div></>
    )
}

export default RecruiterProfile